'use client'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { SvdWishlistCard } from './svd-wishlist.types'
import WishlistItemListSvdDs from './wishlist-item-list-svd-ds'
import WishlistItemListSvdLegacy from './wishlist-item-list-svd-legacy'

interface WishlistItemListSvdProps {
  items: SvdWishlistCard[] | undefined
  isLoading?: boolean
  sectionConfig: { tracker?: string }
  /** Gates the trash icon (STRFRNT-17430) — never rendered on someone else's shared wishlist. */
  isSelfWishlist?: boolean
}

/**
 * SVD wishlist list — picks the layout for the page's DS state, exactly as `wishlist-item-list.tsx`
 * does for the non-SVD lists.
 *
 * The SVD × DS 2×2 needs a branch on BOTH axes and it previously only had one. The page answers "SVD?"
 * (`wishlist-page.tsx`) and `SvdProductCard` answers "DS?" internally to pick a card body — but the
 * *grid around* the card had no DS arm, so a DS page put DS card bodies inside the legacy SCSS grid
 * (columns sized in `rem` for the SCSS body, tile styled by the `product-card-style` mixin). That is
 * the STRFRNT-16908 misalignment: oversized, unaligned tiles versus the non-SVD DS wishlist.
 *
 * Both arms must stay behaviourally identical — same items, same reversal, same tracking, same
 * quick-add. They differ in layout and in the button component only.
 */
function WishlistItemListSvd(props: WishlistItemListSvdProps) {
  if (shouldUseDesignSystem()) {
    return <WishlistItemListSvdDs {...props} />
  }
  return <WishlistItemListSvdLegacy {...props} />
}

export default WishlistItemListSvd
